const config = {
    soundstyle: 'classic',
    appName: 'Wintrado Dev',
    appTitle: 'Wintrado - WebTrader Dev',
    feedApi: {
        url: 'wss://gateway.dev.wintrado.com',
    },
    baseURL: 'https://gateway.dev.wintrado.com',
    cashier: {
        useIframe: false,
        baseURL: 'https://cashier.dev.wintrado.com',
        frontendURL: 'https://app.dev.wintrado.com',
    },
    oAuth: {
        clientId: 'webtrader-wintrado',
        clientSecret: 'rpjsSJvu1HIJvDCe',
    },
    affiliatePortalUrl: 'https://affiliate.dev.wintrado.com',
    gtmId: 'GTM-WPR7S5FK',
};
export default config;
